import { useCurrency } from "@/context/CurrencyContext";

const OPTIONS = ["EUR", "LEK"];

export default function CurrencyToggle() {
    const { currency, setCurrency } = useCurrency();
    return (
        <div className="flex border border-slate-200" data-testid="currency-toggle">
            {OPTIONS.map((c) => (
                <button
                    key={c}
                    onClick={() => setCurrency(c)}
                    className={`px-2 py-1 text-[10px] font-mono font-bold uppercase transition-colors ${
                        currency === c ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-50"
                    }`}
                    data-testid={`currency-${c.toLowerCase()}`}
                >
                    {c === "EUR" ? "€ EUR" : "L Lek"}
                </button>
            ))}
        </div>
    );
}
